/**
 * src/connects/chat-room-delete-panel.js
 */

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import { getArray } from '../helpers/store'

export const mapStateToProps = (state, ownProps)=> {
  return {
		chatRoom: getArray('chat_room_id', state.chatRooms.items, (ownProps.chatRoom || ownProps.chatRoomName).chat_room_id),
    isRequesting: state.chatRooms.isRequesting,
    isRequestFailed: state.chatRooms.isRequestFailed,
    rightSidePage: state.rightSidePage.name
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    deleteChatRoom: (props)=> {
      dispatch(actions.deleteChatRoom(props.chatRoomName.chat_room_id))
      dispatch(emitAlertMessage({ message: 'label:チャットルームを削除しました', name: props.chatRoomName.name }, 'success'))
    },
    willUpdate: (props, nextProps)=> {
      if(props.isRequesting && !nextProps.isRequesting && !nextProps.isRequestFailed && props.rightSidePage == 'chat_rooms'){
        props.onCloseDialog()
      }
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/chat-room-delete-panel.js